const MetaLogo = () => {
  return (
    <svg
      width="276"
      height="75"
      viewBox="0 0 276 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="276" height="75" rx="20" fill="white" fill-opacity="0.5" />
      <g clip-path="url(#clip0_2780_29251)">
        <path
          d="M29.5684 44.9954C29.5684 47.6973 30.1557 49.7717 30.9232 51.0266C31.9296 52.6704 33.4306 53.3668 34.9609 53.3668C36.9346 53.3668 38.7402 52.8722 42.2198 48.0123C45.0074 44.1169 48.2921 38.6492 50.5022 35.2214L54.245 29.414C56.8449 25.3809 59.8543 20.8974 63.3046 17.8584C66.1215 15.378 69.1601 14 72.2181 14C77.3523 14 82.2428 17.0046 85.9855 22.6396C90.0816 28.8112 92.07 36.5846 92.07 44.6066C92.07 49.3755 91.1392 52.8796 89.5553 55.6479C88.0251 58.3252 85.0425 61 80.0253 61V53.3668C84.3213 53.3668 85.3934 49.3804 85.3934 44.8182C85.3934 38.317 83.8924 31.1021 80.5858 25.9469C78.2392 22.2902 75.1982 20.0559 71.8526 20.0559C68.2341 20.0559 65.3222 22.8119 62.0497 27.726C60.3099 30.3368 58.5238 33.5185 56.5184 37.1087L54.3108 41.0582C49.8759 48.999 48.7526 50.8076 46.5352 53.7925C42.6487 59.0191 39.3299 61 34.9609 61C29.778 61 26.5006 58.7337 24.4708 55.3182C22.8139 52.5351 22 48.8834 22 44.7223L29.5684 44.9954Z"
          fill="#0081FB"
        />
        <path
          d="M27.9673 23.1785C31.4372 17.7772 36.4446 14 42.1879 14C45.514 14 48.8206 14.9941 52.2735 17.8412C56.0504 20.954 60.0758 26.0797 65.0979 34.5274L66.8986 37.5591C71.2457 44.8724 73.7189 48.6348 75.1663 50.409C77.028 52.6876 78.3316 53.3668 80.0251 53.3668C84.321 53.3668 85.3932 49.3804 85.3932 44.8182L92.0698 44.6066C92.0698 49.3755 91.139 52.8796 89.5551 55.6479C88.0248 58.3252 85.0423 61 80.0251 61C76.9061 61 74.1429 60.3159 71.0873 57.4049C68.7383 55.1705 65.9921 51.2014 63.8795 47.6333L57.5952 37.0325C54.4421 31.7124 51.5498 27.7457 49.8757 25.9493C48.075 24.0176 45.7601 21.6849 42.0661 21.6849C39.0762 21.6849 36.5372 23.8036 34.4124 27.0443L27.9673 23.1785Z"
          fill="url(#paint0_linear_2780_29251)"
        />
        <path
          d="M42.0663 21.6849C39.0765 21.6849 36.5374 23.8036 34.4126 27.0443C31.4081 31.6238 29.5684 38.4449 29.5684 44.9954C29.5684 47.6973 30.1557 49.7717 30.9232 51.0266L24.4708 55.3182C22.8139 52.5351 22 48.8834 22 44.7223C22 37.1555 24.0566 29.2688 27.9675 23.1785C31.4374 17.7772 36.4448 14 42.1881 14L42.0663 21.6849Z"
          fill="url(#paint1_linear_2780_29251)"
        />
        <path
          d="M106.783 15.4844H115.538L130.424 42.6804L145.312 15.4844H153.877V60.1713H146.735V25.9228L133.679 49.6394H126.978L113.925 25.9228V60.1713H106.783V15.4844ZM176.256 32.146C171.134 32.146 168.049 36.0389 167.311 40.8595H184.694C184.336 35.8937 181.5 32.146 176.256 32.146ZM160.229 43.6056C160.229 33.4625 166.721 26.0803 176.38 26.0803C185.881 26.0803 191.553 33.369 191.553 44.147V46.1279H167.311C168.171 51.3717 171.616 54.9053 177.172 54.9053C181.604 54.9053 184.375 53.5396 187.002 51.042L190.796 55.7346C187.221 59.0541 182.674 60.9686 176.919 60.9686C166.463 60.9686 160.229 53.2689 160.229 43.6056ZM200.213 32.7858H193.639V26.88H200.213V17.1134H207.104V26.88H217.093V32.7858H207.104V47.7544C207.104 52.8654 208.722 54.6814 212.699 54.6814C214.514 54.6814 215.555 54.5239 217.093 54.2655V60.1073C215.177 60.6536 213.35 60.9046 211.371 60.9046C203.932 60.9046 200.213 56.8001 200.213 48.5837V32.7858ZM246.109 38.5291C244.725 35.0005 241.637 32.4019 237.1 32.4019C231.203 32.4019 227.429 36.627 227.429 43.5097C227.429 50.2201 230.904 54.6494 236.818 54.6494C241.467 54.6494 244.786 51.918 246.109 48.5197V38.5291ZM253 60.1713H246.236V55.5107C244.345 58.2544 240.904 60.9686 235.331 60.9686C226.369 60.9686 220.38 53.392 220.38 43.5097C220.38 33.5339 226.513 26.0803 235.711 26.0803C240.258 26.0803 243.826 27.916 246.236 31.1568V26.88H253V60.1713Z"
          fill="#192830"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2780_29251"
          x1="36.8637"
          y1="42.7906"
          x2="85.1129"
          y2="45.2036"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0064E1" />
          <stop offset="0.4" stop-color="#0064E1" />
          <stop offset="0.83" stop-color="#0073EE" />
          <stop offset="1" stop-color="#0082FB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2780_29251"
          x1="32.9652"
          y1="48.2042"
          x2="32.9652"
          y2="30.2408"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0082FB" />
          <stop offset="1" stop-color="#0064E0" />
        </linearGradient>
        <clipPath id="clip0_2780_29251">
          <rect
            width="231"
            height="47"
            fill="white"
            transform="translate(22 14)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export default MetaLogo
